/*
 * humo-collection.js — Humo Commerce
 * Страница коллекции (sections/humo-main-collection.liquid): фильтры, сортировка и «Показать ещё»
 * без перезагрузки через Section Rendering API (?section_id=), URL синхронизируется с history.
 *
 * Контракт с разметкой секции:
 *   [data-humo-collection][data-section-id]  — корень секции
 *   [data-humo-filters-form]                  — GET-форма фильтров (без JS работает как обычная)
 *   [data-humo-filters-body]                  — содержимое формы, заменяется целиком
 *   [data-humo-results]                       — тулбар + сетка + нижние карточки, заменяется целиком
 *   a[data-humo-link]                         — ссылки (активные фильтры, сброс, сортировка) грузим сами
 *   a[data-humo-more] / [data-humo-grid]      — «Показать ещё» дописывает карточки в сетку
 *   [data-humo-sort-select]                   — сортировка на мобильных (value = URL)
 *   [data-humo-drawer-open|close]             — панель фильтров на мобильных
 *
 * «В корзину»: vendor ajaxCart.init() вешает обработчики только при загрузке страницы, повторный
 * init() задвоит их у старых кнопок. Поэтому новые кнопки привязываем сами тем же вызовом
 * Shopify.theme.ajaxCart.addToCart(...). Дубли запросов /cart/add.js дополнительно гасит humo-fixes.js.
 *
 * Обработчики висят на document — секция может перерисоваться в редакторе темы (shopify:section:load).
 * Ошибка загрузки: пишем в консоль и уходим на обычную перезагрузку страницы — страница не зависает.
 */
(function () {
  'use strict';

  var ROOT = '[data-humo-collection]';
  var PRICE_DEBOUNCE = 400;
  var DRAWER_OPEN_CLASS = 'humo-filters-open';

  var cache = {};
  var requestId = 0;
  var controller = null;
  var priceTimer = null;
  var drawerOpener = null;

  function getRoot() {
    return document.querySelector(ROOT);
  }

  // ---------- URL ----------

  // Параметры формы фильтров: без пустых значений и без «Цена до», равной максимуму
  function formUrl(form) {
    var params = new URLSearchParams();
    var data = new FormData(form);
    data.forEach(function (value, name) {
      if (value === '') return;
      var range = form.querySelector('input[type="range"][name="' + name + '"]');
      if (range && Number(value) >= Number(range.max)) return;
      params.append(name, value);
    });
    var query = params.toString();
    return form.getAttribute('action') + (query ? '?' + query : '');
  }

  function sectionUrl(url, sectionId) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  // ---------- Загрузка секции ----------

  function fetchSection(url, sectionId) {
    var key = sectionUrl(url, sectionId);
    if (cache[key]) return Promise.resolve(cache[key]);

    if (controller) controller.abort();
    controller = typeof AbortController === 'function' ? new AbortController() : null;

    return fetch(key, controller ? { signal: controller.signal } : {})
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status + ' for ' + key);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector(ROOT)) throw new Error('No section markup in response for ' + key);
        cache[key] = doc;
        return doc;
      });
  }

  function setBusy(root, busy) {
    var results = root.querySelector('[data-humo-results]');
    if (!results) return;
    results.setAttribute('aria-busy', busy ? 'true' : 'false');
    results.classList.toggle('is-loading', busy);
  }

  function isAbort(error) {
    return error && error.name === 'AbortError';
  }

  function fallback(url, error) {
    console.error('[humo-collection] section load failed, reloading page', error);
    window.location.href = url;
  }

  // Перерисовать фильтры и результаты по URL; push = записать в историю
  function render(url, push) {
    var root = getRoot();
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id');
    var current = ++requestId;
    var activeId = document.activeElement && root.contains(document.activeElement) ? document.activeElement.id : '';

    setBusy(root, true);
    fetchSection(url, sectionId)
      .then(function (doc) {
        if (current !== requestId) return; // пришёл устаревший ответ
        swap(root, doc);
        if (push) window.history.pushState({ humoCollection: true }, '', url);
        restoreFocus(root, activeId);
        setBusy(root, false);
      })
      .catch(function (error) {
        // Прерван новым запросом: если это был «Показать ещё», сами снимаем загрузку
        if (isAbort(error)) {
          if (current === requestId) setBusy(root, false);
          return;
        }
        setBusy(root, false);
        fallback(url, error);
      });
  }

  function replaceNode(root, doc, selector) {
    var target = root.querySelector(selector);
    var source = doc.querySelector(selector);
    if (target && source) target.replaceWith(source.cloneNode(true));
  }

  function swap(root, doc) {
    replaceNode(root, doc, '[data-humo-filters-body]');
    replaceNode(root, doc, '[data-humo-results]');

    var apply = root.querySelector('[data-humo-apply]');
    var newApply = doc.querySelector('[data-humo-apply]');
    if (apply && newApply) apply.textContent = newApply.textContent;

    var reset = root.querySelector('.humo-filters__reset');
    var newReset = doc.querySelector('.humo-filters__reset');
    if (reset && newReset) reset.setAttribute('href', newReset.getAttribute('href'));

    // Кнопка «Фильтр» пересоздана — вернуть ей состояние открытой панели
    var opener = root.querySelector('[data-humo-drawer-open]');
    if (opener && isDrawerOpen(root)) opener.setAttribute('aria-expanded', 'true');

    bindCart(root.querySelector('[data-humo-results]'));
  }

  function restoreFocus(root, id) {
    if (!id) return;
    var el = document.getElementById(id);
    if (el && root.contains(el)) el.focus({ preventScroll: true });
  }

  // ---------- «Показать ещё» ----------

  function loadMore(link) {
    var root = getRoot();
    if (!root) return;
    var url = link.getAttribute('href');
    var sectionId = root.getAttribute('data-section-id');

    link.classList.add('is-loading');
    link.setAttribute('aria-disabled', 'true');
    fetchSection(url, sectionId)
      .then(function (doc) {
        var grid = root.querySelector('[data-humo-grid]');
        var newGrid = doc.querySelector('[data-humo-grid]');
        if (!grid || !newGrid) throw new Error('No product grid in response for ' + url);

        var items = Array.prototype.slice.call(newGrid.children);
        var first = null;
        items.forEach(function (item) {
          var node = item.cloneNode(true);
          grid.appendChild(node);
          // Только новые карточки: у исходных уже есть обработчик vendor ajaxCart
          bindCart(node);
          if (!first) first = node;
        });

        var more = root.querySelector('.humo-collection__more');
        var newMore = doc.querySelector('.humo-collection__more');
        if (more && newMore) more.replaceWith(newMore.cloneNode(true));
        else if (more) more.remove();

        // Фокус — на первую новую карточку, чтобы клавиатура не возвращалась в начало
        var firstLink = first && first.querySelector('.humo-card__title a');
        if (firstLink) firstLink.focus({ preventScroll: true });
      })
      .catch(function (error) {
        if (isAbort(error)) return;
        fallback(url, error);
      });
  }

  // ---------- «В корзину» в подгруженных карточках ----------

  function bindCart(container) {
    if (!container || !window.Shopify || !Shopify.theme || !Shopify.theme.ajaxCart) return;
    var configEl = document.getElementById('cart-config');
    if (!configEl) return;
    var config;
    try {
      config = JSON.parse(configEl.innerHTML || '{}');
    } catch (error) {
      console.error('[humo-collection] invalid #cart-config JSON', error);
      return;
    }

    container.querySelectorAll('.js-ajax-submit:not([data-humo-bound])').forEach(function (button) {
      button.setAttribute('data-humo-bound', '');
      button.addEventListener('click', function (event) {
        event.preventDefault();
        Shopify.theme.ajaxCart.addToCart(
          button.closest('form'),
          button.parentNode,
          config,
          false,
          button.hasAttribute('data-quick-add')
        );
      });
    });
  }

  // ---------- Панель фильтров на мобильных ----------

  function isDrawerOpen(root) {
    var panel = root.querySelector('[data-humo-filters]');
    return !!panel && panel.classList.contains('is-open');
  }

  function openDrawer(root, opener) {
    var panel = root.querySelector('[data-humo-filters]');
    var overlay = root.querySelector('.humo-filters__overlay');
    if (!panel) return;
    drawerOpener = opener || null;
    panel.classList.add('is-open');
    if (overlay) overlay.hidden = false;
    document.documentElement.classList.add(DRAWER_OPEN_CLASS);
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var close = panel.querySelector('.humo-filters__close');
    if (close) close.focus();
  }

  function closeDrawer(root) {
    var panel = root.querySelector('[data-humo-filters]');
    var overlay = root.querySelector('.humo-filters__overlay');
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open');
    if (overlay) overlay.hidden = true;
    document.documentElement.classList.remove(DRAWER_OPEN_CLASS);
    var opener = root.querySelector('[data-humo-drawer-open]');
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      // Исходная кнопка могла быть заменена при перерисовке — фокус на актуальную
      (drawerOpener && document.contains(drawerOpener) ? drawerOpener : opener).focus();
    }
    drawerOpener = null;
  }

  // ---------- Обработчики ----------

  document.addEventListener('change', function (event) {
    var target = event.target;
    var root = target.closest(ROOT);
    if (!root) return;

    if (target.matches('[data-humo-sort-select]')) {
      render(target.value, true);
      return;
    }

    var form = target.closest('[data-humo-filters-form]');
    if (!form) return;

    if (target.type === 'range') {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () {
        render(formUrl(form), true);
      }, PRICE_DEBOUNCE);
      return;
    }
    render(formUrl(form), true);
  });

  // Подпись «Цена до» обновляется при перетаскивании, загрузка — по change
  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!target.matches('[data-humo-price-input]')) return;
    var group = target.closest('[data-humo-price]');
    var output = group && group.querySelector('[data-humo-price-output]');
    if (!output) return;
    var digits = String(Math.round(Number(target.value))).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    output.textContent = digits + (group.getAttribute('data-currency-suffix') || '');
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('[data-humo-filters-form]') || !form.closest(ROOT)) return;
    event.preventDefault();
    render(formUrl(form), true);
  });

  document.addEventListener('click', function (event) {
    var root = event.target.closest(ROOT);
    if (!root) return;

    var more = event.target.closest('a[data-humo-more]');
    if (more) {
      event.preventDefault();
      if (more.getAttribute('aria-disabled') !== 'true') loadMore(more);
      return;
    }

    var link = event.target.closest('a[data-humo-link]');
    if (link) {
      // Новая вкладка / окно — не перехватываем
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
      event.preventDefault();
      render(link.getAttribute('href'), true);
      return;
    }

    var opener = event.target.closest('[data-humo-drawer-open]');
    if (opener) {
      openDrawer(root, opener);
      return;
    }

    if (event.target.closest('[data-humo-drawer-close]')) {
      closeDrawer(root);
    }
  });

  document.addEventListener('keydown', function (event) {
    var root = getRoot();
    if (!root || !isDrawerOpen(root)) return;

    if (event.key === 'Escape') {
      closeDrawer(root);
      return;
    }

    // Панель открыта поверх страницы: Tab / Shift+Tab ходят по кругу внутри неё
    if (event.key !== 'Tab') return;
    var panel = root.querySelector('[data-humo-filters]');
    var focusable = Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])'),
      function (el) { return el.offsetParent !== null || el.getClientRects().length > 0; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });

  // Назад / вперёд: перерисовать по текущему адресу без новой записи в истории
  window.addEventListener('popstate', function () {
    if (!getRoot()) return;
    render(window.location.href, false);
  });

  // Редактор темы перерисовал секцию: сбросить кэш и снять блокировку прокрутки
  document.addEventListener('shopify:section:load', function () {
    cache = {};
    document.documentElement.classList.remove(DRAWER_OPEN_CLASS);
  });
})();
